import Vue from 'vue/dist/vue.esm.js'
export default new Vue();